import React from "react"
import { Navigate } from "react-router-dom"
import ErrorPage from "../error-page"
import LiveRoom from "../MainScreen/LiveKitRoomScreen"
import { PostScreen } from "../PostScreen/PostScreen"
import { PreScreenCustomBranding } from "../PreScreen/CustomBranding"

export const getRouterData = (isAuthenticated: boolean) => {
  const commonRoutes = [
    {
      path: `rooms/:id/`,
      element: <LiveRoom />,
      errorElement: <ErrorPage />,
    },
    {
      path: `rooms/:id/post`,
      element: <PostScreen />,
      errorElement: <ErrorPage />,
    },
  ]

  const routes = [
    {
      path: "/",
      element: <PreScreenCustomBranding />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/:id",
      element: <PreScreenCustomBranding />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/agent/:id",
      element: <PreScreenCustomBranding />,
      errorElement: <ErrorPage />,
    },
    ...(isAuthenticated ? commonRoutes : []),
    {
      path: "*",
      element: <Navigate to="/" />,
      errorElement: <ErrorPage />,
    },
  ]

  return routes
}
